import React from 'react';

const FORM_SENT = 5;
class DankeBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    
  }

    render() { 
      let zeigeDankeForm = "danke-block modal " +  ((this.props.formIsValid === FORM_SENT) ? 'open' : '');
       return (
        <aside className={zeigeDankeForm}>
          <section className="modalcontainer">
          <img src="/images/i_dankeherz.svg" alt="" />
            <h4 className="center">Danke für dein Rezept!<br/>Sobald wir dein Rezept geprüft haben schalten wir es frei.</h4>
            <a className="btn stdrose center" href="//rezepte.odernichtoderdoch.de/">Zurück zum Kochbuch</a><a className="btn stdrose center" href="//odernichtoderdoch.de/">Zurück zum Shop</a>
            </section>
        </aside>
      
           
      );
    }
  }
export default DankeBlock;


// WEBPACK FOOTER //
// ./src/DankeBlock.js